import React from "react";
import { connect } from "react-redux";
import { Route, Redirect, withRouter } from "react-router-dom";
import NotFoundPage from "../Templates/NotFoundPage"
//custom Protected component to ensure users can only access certain information when they are logged in.
//If the user visits a login or signup page, the Auth component will redirect them to dashboard page if they are already logged in.

// Passed in from parent component or from mapStateToProps
const Auth = ({ component: Component, path, loggedIn, exact }) => {   
    return <Route
        path={path}
        exact={exact}
        render={props =>
            !loggedIn ? (
                <Component {...props} />
            ) : (
                    // Redirect to the dashboard if the user is already logged in. (they can no longer access login page)
                    <Redirect to="/dashboard" />
                )
        }
    />
};

const Protected = ({ component: Component, loggedIn, ...rest }) => {
    return <Route
        {...rest}
        render={props =>
            loggedIn ? (
                <Component {...props} />
            ) : (
                    // Redirect to the login page if the user is not authenticated
                    <Redirect to="/login" />
                )
        }
    />
};

const Uploader = ({ component: Component, loggedIn, role, ...rest }) => {
    let isValidRole = ["Dev", "Engineer"].includes(role)
    return <Route
        {...rest}
        render={props => {
            if (loggedIn && ( isValidRole)) {
                return <Component {...props} />
            } else if ((loggedIn && !isValidRole)) {
                return <NotFoundPage />
            } else if (!loggedIn) {
                return <Redirect to="/login" />
            }
        }}
    />
};


const Manager = ({ component: Component, loggedIn, role, ...rest }) => {
    let isValidRole = ["Dev", "Work Lead", "Shop Supervisor"].includes(role)
    return <Route
        {...rest}
        render={props => {
            if (loggedIn && (isValidRole)) {
                return <Component {...props} />
            } else if ((loggedIn && !isValidRole)) {
                return <NotFoundPage />
            } else if (!loggedIn) {
                return <Redirect to="/login" />
            }
        }}
    />
};

const Author = ({ component: Component, loggedIn, role, ...rest }) => {
    let isValidRole = ["Dev", "E&E", "Engineer"].includes(role)
    return <Route
        {...rest}
        render={props => {
            if (loggedIn && (isValidRole)) {
                return <Component {...props} />
            } else if ((loggedIn && !isValidRole)) {
                return <NotFoundPage />
            } else if (!loggedIn) {
                return <Redirect to="/login" />
            }
        }}
    />
};

const Parent = ({ component: Component, loggedIn, role, ...rest }) => {
    let isValidRole = ["Dev", "E&E", "Engineer"].includes(role)
    return <Route
        {...rest}
        render={props => {
            if (loggedIn && (isValidRole)) {
                return <Component {...props} />
            } else if ((loggedIn && !isValidRole)) {
                return <NotFoundPage />
            } else if (!loggedIn) {
                return <Redirect to="/login" />
            }
        }}
    />
};



// Use the isAuthenitcated slice of state to determine whether a user is logged in

const mapStateToProps = state => {
    return { 
        loggedIn: state.session.isAuthenticated, 
        role: state.session.user ? state.session.user.role : undefined
    }
};

export const AuthRoute = withRouter(connect(mapStateToProps)(Auth));
export const ProtectedRoute = withRouter(connect(mapStateToProps)(Protected));
export const ParentRoute = withRouter(connect(mapStateToProps)(Parent))
export const UploaderRoute = withRouter(connect(mapStateToProps)(Uploader));
export const AuthorRoute = withRouter(connect(mapStateToProps)(Author));
export const ManagerRoute = withRouter(connect(mapStateToProps)(Manager));